import { ref } from 'vue';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';
import { useEmployeePhotos } from '@/composables/useEmployeePhotos';

export function useFetchDashboardDay() {
  const data = ref({ rosters: [], attendance: [], not_logout: [] });
  const error = ref(null);
  const loading = ref(false);
  const { attachEmployeePhotos } = useEmployeePhotos();

  const fetchDashboardDay = async (date, signal) => {
    loading.value = true;
    error.value = null;

    try {
      const response = await axiosClient.get(
        API_ENDPOINTS.fetchDashboardDay.replace('{date}', date),
        { signal }
      );
      data.value = {
        ...response.data,
        rosters: attachEmployeePhotos(response.data?.rosters || []),
        attendance: attachEmployeePhotos(response.data?.attendance || []),
        not_logout: attachEmployeePhotos(response.data?.not_logout || [])
      };
      return data.value;
    } catch (requestError) {
      if (requestError?.code !== 'ERR_CANCELED') {
        error.value = requestError.response?.data?.error || 'Failed to load dashboard data.';
      }
      throw requestError;
    } finally {
      loading.value = false;
    }
  };

  return { data, error, loading, fetchDashboardDay };
}
